import * as tslib_1 from "tslib";
import { Directive, ElementRef, Input, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { LinkDirective } from './link.directive';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
let RouterLinkDirective = class RouterLinkDirective extends LinkDirective {
    constructor(viewContainer, templateRef, renderer, elementRef, router) {
        super(viewContainer, templateRef, renderer, elementRef);
        this.router = router;
        // tslint:disable-next-line:no-input-rename
        this.editable = true;
        // tslint:disable-next-line:no-input-rename
        this.attrs = {};
    }
    renderTemplate(props, linkText) {
        const viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
        viewRef.rootNodes.forEach((node) => {
            Object.entries(props).forEach(([key, propValue]) => {
                this.renderer.setAttribute(node, key, propValue);
                if (key === 'href') {
                    this.renderer.listen(node, 'click', (event) => {
                        this.router.navigate([propValue]);
                        event.preventDefault();
                    });
                }
            });
            if (node.childNodes && node.childNodes.length === 0 && linkText) {
                node.textContent = linkText;
            }
        });
    }
};
RouterLinkDirective.ɵfac = function RouterLinkDirective_Factory(t) { return new (t || RouterLinkDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router)); };
RouterLinkDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RouterLinkDirective, selectors: [["", "scRouterLink", ""]], inputs: { editable: ["scRouterLinkEditable", "editable"], attrs: ["scRouterLinkAttrs", "attrs"], field: ["scRouterLink", "field"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
RouterLinkDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: Renderer2 },
    { type: ElementRef },
    { type: Router }
];
tslib_1.__decorate([
    Input('scRouterLinkEditable')
], RouterLinkDirective.prototype, "editable", void 0);
tslib_1.__decorate([
    Input('scRouterLinkAttrs')
], RouterLinkDirective.prototype, "attrs", void 0);
tslib_1.__decorate([
    Input('scRouterLink')
], RouterLinkDirective.prototype, "field", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RouterLinkDirective, [{
        type: Directive,
        args: [{ selector: '[scRouterLink]' }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc1.Router }]; }, { editable: [{
            type: Input,
            args: ['scRouterLinkEditable']
        }], attrs: [{
            type: Input,
            args: ['scRouterLinkAttrs']
        }], field: [{
            type: Input,
            args: ['scRouterLink']
        }] }); })();
export { RouterLinkDirective };
